import { ContractDataWithLinks, FetchContractError } from 'cpes-common';
import { createGetContractBasedDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { AxiosRequestConfig } from 'axios';

const { reducer, fetchData } = createGetContractBasedDataFetchSlice<ContractDataWithLinks[], FetchContractError>({
    dataName: 'smeContracts',
    fetchCallback(link: string, requestConfig?: AxiosRequestConfig) {
        return CpDataApi.get(link, requestConfig).then(response => response.data);
    },
});

export default reducer;
export const fetchSmeContracts = fetchData;
